import React from 'react';
import { get } from 'lodash';
import Currency from '$app/components/vendor/Currency';
import { Tooltip } from 'antd';
import { renderSlotData } from './utils';
import GarageInfo from '$app/shared/components/GarageInfo/GarageInfo';
import { CantDoWorkTag, CoverageIcon, GarageName } from './styled';

const getColumns = (isGarageCnd) => [
  {
    title: 'Garage',
    dataIndex: 'businessName',
    render: (val, garage) => (
      <GarageName>
        <GarageInfo garage={garage} />
        {garage.canPerformAllWorkForBooking === false && (
          <CantDoWorkTag>Can&#39;t perform work</CantDoWorkTag>
        )}
      </GarageName>
    ),
  },
  {
    title: 'Distance',
    dataIndex: '',
    render: (val, garage) => {
      const { collectionRoundedMiles, deliveryRoundedMiles } = garage;
      if (collectionRoundedMiles === deliveryRoundedMiles) return `C&D: ${collectionRoundedMiles} miles`;
      return (
        <>
          Collection: {garage.collectionRoundedMiles}mi <br />
          Delivery: {garage.deliveryRoundedMiles}mi
        </>
      );
    },
  },
  {
    title: 'Rates',
    dataIndex: 'operations',
    render: (val) => {
      const labourRate = get(val, 'labourRate.price', '-');
      const mot = get(val, 'mot.price', '-');
      return (
        <>
          Labour: <Currency trailingZero>{labourRate}</Currency>
          <br />
          MOT: <Currency trailingZero>{mot}</Currency>
        </>
      );
    },
  },
  {
    title: 'Repairs & Services Slots',
    render: (val, { currentRepairsAllocation, maxRepairsCapacity }) =>
      renderSlotData(currentRepairsAllocation, maxRepairsCapacity),
  },
  {
    title: 'MOT Slots',
    render: (val, { currentMotAllocation, maxMotCapacity }) =>
      renderSlotData(currentMotAllocation, maxMotCapacity),
  },
  {
    title: 'Coverage',
    render: (val, { coversBookingLocation }) => {
      if (!isGarageCnd) return '-';
      return coversBookingLocation ? (
        <Tooltip title="Booking within Garage C&D zone">
          <CoverageIcon type="check-square" className="in-coverage" theme="filled" />
        </Tooltip>
      ) : (
        <Tooltip title="Booking outside of Garage C&D zone">
          <CoverageIcon type="warning" className="out-of-coverage" theme="filled" />
        </Tooltip>
      );
    },
  },
  {
    title: 'C&D Slots',
    render: (val, { currentCnd, maxCnd }) => renderSlotData(currentCnd, maxCnd),
  },
];

export default getColumns;
